/* AlleyOop Athletics — interactions for skinned sections.
   Event-delegated so it survives Shopify section re-renders in the editor. */
(function () {
  'use strict';

  // Guard against duplicate initialization (script may be referenced by
  // multiple sections / re-rendered in the theme editor).
  if (window.__aoInit) return;
  window.__aoInit = true;

  // PDP gallery: move the carousel to a given slide index and keep the
  // active thumbnail, counter and slide state in sync. Used by the thumbnails,
  // the prev/next arrows, swipe gestures, and variant selection.
  function aoGalleryGo(pdp, idx) {
    var track = pdp.querySelector('[data-gal-track]');
    var slides = track ? track.querySelectorAll('[data-gal-slide]') : [];
    if (!track || !slides.length) return;
    if (idx < 0) idx = 0;
    if (idx > slides.length - 1) idx = slides.length - 1;

    track.style.transform = 'translateX(-' + idx * 100 + '%)';
    slides.forEach(function (s) {
      s.classList.toggle('active', parseInt(s.getAttribute('data-gal-slide'), 10) === idx);
    });
    pdp.querySelectorAll('.m-gal-thumb').forEach(function (t) {
      t.classList.toggle('active', parseInt(t.getAttribute('data-media-index'), 10) === idx);
    });
    var counter = pdp.querySelector('[data-gal-current]');
    if (counter) counter.textContent = idx + 1;

    var gallery = pdp.querySelector('[data-ao-gallery]');
    if (gallery) gallery.setAttribute('data-gal-idx', idx);
  }

  // Accordions (collection FAQ + PDP details)
  document.addEventListener('click', function (e) {
    var head = e.target.closest('.m-acc-h');
    if (head) {
      var acc = head.closest('.m-acc');
      if (acc) acc.classList.toggle('open');
      return;
    }

    // Featured products tabs
    var tab = e.target.closest('.m-feat-tab');
    if (tab) {
      var tabs = tab.closest('.m-feat-tabs');
      var section = tab.closest('[data-ao-featured]');
      if (!tabs || !section) return;
      tabs.querySelectorAll('.m-feat-tab').forEach(function (t) { t.classList.remove('active'); });
      tab.classList.add('active');
      var key = tab.getAttribute('data-tab');
      section.querySelectorAll('[data-tab-panel]').forEach(function (p) {
        p.style.display = p.getAttribute('data-tab-panel') === key ? '' : 'none';
      });
      return;
    }
  });

  // PDP: gallery carousel — thumbnails + prev/next arrows
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('.m-gal-thumb[data-media-index]');
    if (thumb) {
      var galRoot = thumb.closest('[data-ao-pdp]');
      if (!galRoot) return;
      aoGalleryGo(galRoot, parseInt(thumb.getAttribute('data-media-index'), 10) || 0);
      return;
    }

    var arrow = e.target.closest('[data-gal-prev], [data-gal-next]');
    if (arrow) {
      var arrowRoot = arrow.closest('[data-ao-pdp]');
      var gallery = arrowRoot && arrowRoot.querySelector('[data-ao-gallery]');
      if (!gallery) return;
      var cur = parseInt(gallery.getAttribute('data-gal-idx'), 10) || 0;
      aoGalleryGo(arrowRoot, arrow.hasAttribute('data-gal-next') ? cur + 1 : cur - 1);
      return;
    }
  });

  // PDP gallery: swipe on touch devices
  (function () {
    var startX = null, startY = null, swipePdp = null;
    document.addEventListener('touchstart', function (e) {
      var track = e.target.closest('[data-gal-track]');
      if (!track) { swipePdp = null; return; }
      swipePdp = track.closest('[data-ao-pdp]');
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
    }, { passive: true });
    document.addEventListener('touchend', function (e) {
      if (startX === null || !swipePdp) return;
      var dx = e.changedTouches[0].clientX - startX;
      var dy = e.changedTouches[0].clientY - startY;
      // Only treat mostly-horizontal moves as swipes so vertical scrolling still works.
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
        var gallery = swipePdp.querySelector('[data-ao-gallery]');
        var cur = gallery ? (parseInt(gallery.getAttribute('data-gal-idx'), 10) || 0) : 0;
        aoGalleryGo(swipePdp, dx < 0 ? cur + 1 : cur - 1);
      }
      startX = startY = null; swipePdp = null;
    }, { passive: true });
  })();

  // Categories slider arrows
  document.addEventListener('click', function (e) {
    var prev = e.target.closest('[data-cats-prev]');
    var next = e.target.closest('[data-cats-next]');
    if (prev || next) {
      var inner = (prev || next).closest('.m-cats-inner');
      var grid = inner && inner.querySelector('.m-cats-grid');
      if (grid) {
        var card = grid.querySelector('.m-cat');
        var amt = card ? (card.offsetWidth + 14) : Math.round(grid.clientWidth * 0.8);
        grid.scrollBy({ left: prev ? -amt : amt, behavior: 'smooth' });
      }
      return;
    }
  });

  // Product-card inline add-to-cart (native + AlleyOop cards)
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-atc-toggle]');
    if (toggle) {
      var atc = toggle.closest('[data-ao-atc]');
      if (!atc) return;
      var open = atc.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      var panel = atc.querySelector('[data-atc-panel]');
      if (panel) panel.hidden = !open;
      return;
    }
    var closeBtn = e.target.closest('[data-atc-close]');
    if (closeBtn) {
      var atcC = closeBtn.closest('[data-ao-atc]');
      if (!atcC) return;
      atcC.classList.remove('is-open');
      var tgl = atcC.querySelector('[data-atc-toggle]');
      if (tgl) tgl.setAttribute('aria-expanded', 'false');
      var panelC = atcC.querySelector('[data-atc-panel]');
      if (panelC) panelC.hidden = true;
      return;
    }
    var size = e.target.closest('[data-atc-size]');
    if (size) {
      if (size.hasAttribute('disabled')) return;
      var atcS = size.closest('[data-ao-atc]');
      if (!atcS) return;
      var form = atcS.querySelector('form');
      var idInput = atcS.querySelector('[data-atc-id]');
      if (form && idInput) {
        idInput.value = size.getAttribute('data-variant-id');
        if (form.requestSubmit) form.requestSubmit(); else form.submit();
      }
      return;
    }
  });

  // Size selection -> set form variant id, price, availability (PDP)
  document.addEventListener('change', function (e) {
    var input = e.target.closest('.m-size input[type="radio"]');
    if (!input) return;
    var pdp = input.closest('[data-ao-pdp]');
    if (!pdp) return;

    pdp.querySelectorAll('.m-size').forEach(function (s) { s.classList.remove('active'); });
    var label = input.closest('.m-size');
    if (label) label.classList.add('active');

    var variantId = input.value;
    var available = input.getAttribute('data-available') === 'true';
    var price = input.getAttribute('data-price') || '';

    var form = pdp.querySelector('form');
    if (form) {
      var hidden = form.querySelector('input[name="id"]');
      if (hidden) hidden.value = variantId;
    }
    var atc = pdp.querySelector('.m-pp-atc');
    if (atc) {
      atc.disabled = !available;
      atc.textContent = available ? (atc.getAttribute('data-label') || '+ Agregar al carrito') : 'Agotado';
    }
    if (price) {
      pdp.querySelectorAll('[data-ao-live-price]').forEach(function (el) { el.textContent = price; });
    }

    // Move the gallery to the image attached to the selected variant, so the
    // shopper gets a visual confirmation of which model they picked.
    var mediaId = input.getAttribute('data-media-id');
    if (mediaId) {
      var slide = pdp.querySelector('[data-gal-slide][data-media-id="' + mediaId + '"]');
      if (slide) aoGalleryGo(pdp, parseInt(slide.getAttribute('data-gal-slide'), 10) || 0);
    }
  });

  // PDP gallery: land on the pre-selected variant's image on load.
  // The script is deferred, so the DOM is already parsed here.
  document.querySelectorAll('[data-ao-pdp]').forEach(function (pdp) {
    if (!pdp.querySelector('[data-gal-track]')) return;
    var checked = pdp.querySelector('.m-size input[type="radio"]:checked');
    var startIdx = 0;
    if (checked) {
      var mid = checked.getAttribute('data-media-id');
      if (mid) {
        var slide = pdp.querySelector('[data-gal-slide][data-media-id="' + mid + '"]');
        if (slide) startIdx = parseInt(slide.getAttribute('data-gal-slide'), 10) || 0;
      }
    }
    if (startIdx > 0) aoGalleryGo(pdp, startIdx);
  });

  // "Completa tu fit" no lleva JS de alta al carrito: el bloque emite un form de
  // producto nativo (pixel-safe) y el mini-carrito lo intercepta y abre el drawer.

  // Drawer de filtros en movil. Hasta ahora el panel estaba oculto en
  // pantallas chicas y el 60% del trafico navega en webview.
  function aoFilterDrawer(open) {
    var panel = document.querySelector('[data-ao-filter-panel]');
    var overlay = document.querySelector('.m-coll-side-overlay');
    if (!panel) return;
    panel.classList.toggle('is-open', open);
    if (overlay) overlay.classList.toggle('is-open', open);
    document.body.classList.toggle('ao-noscroll', open);
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-ao-filter-open]')) {
      e.preventDefault();
      aoFilterDrawer(true);
      return;
    }
    if (e.target.closest('[data-ao-filter-close]')) {
      e.preventDefault();
      aoFilterDrawer(false);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var panel = document.querySelector('[data-ao-filter-panel].is-open');
    if (panel) aoFilterDrawer(false);
  });
})();
